export const useProductSubCategoriesStore = defineStore('productSubCategories', {
  state: () => ({
    productSubCategories: null as PaginatedProductSubCategory | null,
  }),
  getters: {
    getProductSubCategories: (state) =>
      state.productSubCategories !== null ? state.productSubCategories.items : [],
  },
  actions: {
    setProductSubCategories(productSubCategories: PaginatedProductSubCategory) {
      useLocalStorage().setItem('productSubCategories', productSubCategories);
      this.productSubCategories = productSubCategories;
    },
    async createProductSubCategory(
      productSubCategory: ProductSubCategoryCreateUpdate,
    ): Promise<ProductSubCategory | undefined> {
      try {
        const {data} = await apiPostProductSubCategory(productSubCategory);
        // Push the object to state.
        if (this.productSubCategories !== null) {
          this.productSubCategories.items.push(data);
          useLocalStorage().setItem('productSubCategories', this.productSubCategories);
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductSubCategories(
      limit: number = 500,
      offset: number = 0,
    ): Promise<PaginatedProductSubCategory | undefined> {
      // Parse the local storage value & set the state.
      const localStorageProductSubCategories: PaginatedProductSubCategory | null =
        useLocalStorage().getItem('productSubCategories');
      if (localStorageProductSubCategories)
        this.setProductSubCategories(localStorageProductSubCategories);
      try {
        const {data} = await apiGetProductSubCategories(limit, offset);
        this.setProductSubCategories(data);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async readProductSubCategoryById(id: string | number): Promise<ProductSubCategory | undefined> {
      // Parse & return the local storage value.
      const localStorageProductSubCategories: PaginatedProductSubCategory | null =
        useLocalStorage().getItem('productSubCategories');
      if (localStorageProductSubCategories) {
        const foundProductSubCategory = localStorageProductSubCategories.items.find(
          (p) => p.id === id,
        );
        if (foundProductSubCategory !== undefined) return foundProductSubCategory;
      }
      try {
        const {data} = await apiGetProductSubCategory(id);
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async updateProductSubCategory(
      productSubCategory: ProductSubCategoryCreateUpdate,
    ): Promise<ProductSubCategory | undefined> {
      try {
        const response = await apiPutProductSubCategory(productSubCategory);
        const data: ProductSubCategory = response.data;
        // Find & update the target object.
        if (this.productSubCategories !== null) {
          const index = this.productSubCategories.items.findIndex((p) => p.id === data.id);
          if (index >= 0) {
            Object.assign(this.productSubCategories.items[index], data);
            useLocalStorage().setItem('productSubCategories', this.productSubCategories);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
    async deleteProductSubCategory(id: string | number): Promise<ProductSubCategory | undefined> {
      try {
        const {data} = await apiDeleteProductSubCategory(id);
        // Find & remove the element.
        if (this.productSubCategories !== null) {
          const index = this.productSubCategories.items.findIndex((p) => p.id === id);
          if (index >= 0) {
            this.productSubCategories.items.splice(index, 1);
            useLocalStorage().setItem('productSubCategories', this.productSubCategories);
          }
        }
        return data;
      } catch (error) {
        throw apiErrorMessage(error);
      }
    },
  },
});
